import React from "react";
import { Modal, ModalContent, ModalFooter } from "@/components/ui/modal";
import { Button } from "@/components/ui/button";

interface DocumentNotFoundModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentType: 'CPF' | 'CNPJ';
}

const DocumentNotFoundModal: React.FC<DocumentNotFoundModalProps> = ({ isOpen, onClose, documentType }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        {/* Icon */}
        <div className="mb-6">
          <img
            src="/icon_modal_document_not_found.svg"
            alt={`${documentType} não encontrado`}
            className="w-16 h-16"
          />
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Este {documentType} não é elegível
        </h2>

        {/* Description */}
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          Para mais informações, entre em contato com nosso atendimento através do{" "}
          <span className="font-semibold">10631</span>
        </p>
      </ModalContent>

      <ModalFooter>
        <Button
          onClick={onClose}
          className="w-full border border-primary text-primary bg-white hover:bg-gray-50"
        >
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DocumentNotFoundModal;
